module.exports = __webpack_public_path__ + "img/ico-order.2acd4950.svg";